import script from "./LangPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./LangPopup.vue?vue&type=script&lang=ts&setup=true"

import "./LangPopup.vue?vue&type=style&index=0&id=083755f2&lang=scss&scoped=true"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083755f2"]])

export default __exports__